export enum roles {
  ADMIN = 'admin',
  USER = 'user',
}
